export const schema = {
  settings: [
    {
      question_id: 1,
      unit: "$",
      type: "package",
      rangeData: [
        {
          min: 0,
          max: 0,
          zoneData: [
            {
              price: 0,
              zone_id: 1,
            },
            {
              price: 0,
              zone_id: 2,
            },
          ],
        },
        {
          min: 0,
          max: 0,
          zoneData: [
            {
              price: 0,
              zone_id: 1,
            },
            {
              price: 0,
              zone_id: 2,
            },
          ],
        },
      ],
      dimensions: [
        {
          min_length: 0,
          min_width: 0,
          min_height: 0,
          max_length: 0,
          max_width: 0,
          max_height: 0,
          zoneData: [
            {
              price: 0,
              zone_id: 1,
            },
            {
              price: 0,
              zone_id: 2,
            },
          ],
        },
      ],
      zoneData: [
        {
          price: 0,
          zone_id: 1,
        },
      ],
    },
  ],
};
